import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'state/global-state/store';

export const selectContentCards = ({ loyalty }: RootState) => loyalty.contentCards.contentCards;

export const selectNewsFeedContentCards = ({ loyalty }: RootState) =>
  loyalty.contentCards.newsFeedContentCards;

export const selectHomePageFeedContentCards = ({ loyalty }: RootState) =>
  loyalty.contentCards.homePageFeedContentCards;

export const selectUnreadContentCards = ({ loyalty }: RootState) =>
  loyalty.contentCards.unreadContentCards;

export const selectWebContentCards = ({ loyalty }: RootState) =>
  loyalty.contentCards.webContentCards;

export const selectBrazeContentCards = createSelector(
  selectContentCards,
  selectNewsFeedContentCards,
  selectHomePageFeedContentCards,
  selectUnreadContentCards,
  selectWebContentCards,
  (
    contentCards,
    newsFeedContentCards,
    homePageFeedContentCards,
    webContentCards,
    unreadContentCards
  ) => {
    return {
      contentCards: contentCards || [],
      newsFeedContentCards: newsFeedContentCards || [],
      homePageFeedContentCards: homePageFeedContentCards || [],
      webContentCards: webContentCards || [],
      unreadContentCards,
    };
  }
);
